import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

export default function RghtSdebar() {
  const [activeTab, setActiveTab] = useState("home");

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
  };
  return (
    <div>
      <aside
        id="right-sidebar"
        className="collapsed expand"
        style={{
          backgroundColor: "white",
          color: "red",
          borderRight: "2px solid black",
          width: "300px", 
          
        }}
      >
        <div className="mb-3">
          <div className="nav nav-tabs">
            <div
              className={`nav-item nav-link ${
                activeTab === "home" ? "active" : ""
              }`}
              onClick={() => handleTabClick("home")}
              style={{ color: "red" }}
            >
              Home
            </div>
            <div
              className={`nav-item nav-link ${
                activeTab === "profile" ? "active" : ""
              }`}
              onClick={() => handleTabClick("profile")}
              style={{ color: "red" }}
            >
              Profile
            </div>
          </div>

          <div className="tab-content">
            {activeTab === "home" && (
              <div className="tab-pane" style={{ color: "red" }}>
                <h2>Welcome to the Home Tab!</h2>
                <p>
                  This is the content for the Home tab. Feel free to add any
                  information or components you need.
                </p>{" "}
              </div>
            )}
            {activeTab === "profile" && (
              <div className="tab-pane" style={{ color: "red" }}>
                <h2>User Profile</h2>
                <p>
                  This is the content for the Profile tab. You can display
                  user-specific information and details here.
                </p>{" "}
              </div>
            )}
          </div>
        </div>
      </aside>
    </div>
  );
}
